import React from "react";
import { Link } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import "./cookies.scss"

const Cookies = () => {

    return (
        <CookieConsent
            location="bottom"
            enableDeclineButton
            flipButtons
            buttonText={"Zustimmen"}
            declineButtonText={"Ablehnen"}
            cookieName="cookieConsent"
            contentClasses="content"
            expires={365}
            overlay={true}
        >
            <h3>Ihre Privacy ist uns wichtig</h3>
            <span>Wir verwenden Cookies, um Ihnen alle Funktionen von mk-lorenzen.it zu ermöglichen und Inhalte entsprechend Ihren Interessen zu personalisieren. Einige dieser Daten können an Partnerunternehmen weitergegeben und zur Personalisierung von Anzeigen genutzt werden. Weitere Informationen finden Sie in unseren <Link to={"/cookies"}>Cookie-Richtlinien</Link>.</span>
        </CookieConsent>
    )
};

export default Cookies